export default __webpack_public_path__ + "static/media/My-affiliate-link-Grey.d388cf0f.svg";